import Cookies from 'js-cookie'
import Vue from 'vue'
import getIsWx from '@/mixins/getIsWx'
Vue.mixin({
  mixins: [getIsWx],
  data() {
    return {
      ecloud_token: '',
      token: '',
      identity: '',
      hasUrl: ''
    }
  },
  created() {
    if (Cookies.get('token') === 'undefined') {
      Cookies.remove('token')
    }
    if (Cookies.get('mall_token') === 'undefined') {
      Cookies.remove('mall_token')
    }
    if (Cookies.get('identity') === 'undefined') {
      Cookies.remove('identity')
    }
    if (!this.$route) {
      return
    }
    if (
      this.$route.query.identity &&
      this.$route.query.identity !== 'undefined'
    ) {
      Cookies.set('identity', this.$route.query.identity)
    }
    this.identity = Cookies.get('identity')
    this.token = Cookies.get('token')
    // console.log('统一处理token', this.token)
    this.ecloud_token = Cookies.get('mall_token')
  },
  methods: {
    /**
 2  * 删除URL中的指定参数
 3  * @param {*} url
 4  * @param {*} name
 5  */
    delUrlParams(url, name) {
      // 根据#号拆分
      const poundArr = url.split('#')
      // ？拆分
      let questionArr = []
      if (poundArr) {
        // 把#接上
        poundArr.forEach((element, index) => {
          if (index > 0) {
            element = '#' + element
          }

          const tempArr = element.split('?')
          if (!tempArr) {
            return true
          }
          tempArr.forEach((item, idx) => {
            // 保留问号
            if (idx > 0) {
              item = '?' + item
            }
            questionArr.push(item)
          })
        })
      } else {
        questionArr = url.split('?')
        if (questionArr) {
          questionArr.forEach((item, idx) => {
            if (idx > 0) {
              item = '?' + item
            }
          })
        }
      }

      if (!questionArr) {
        return url
      }

      // &符号的处理
      const andArr = []
      questionArr.forEach((item) => {
        const andIdx = item.indexOf('&')
        if (andIdx <= -1) {
          andArr.push(item)
          return true
        }

        const tempAndArr = item.split('&')
        tempAndArr.forEach((ele, idx) => {
          if (idx > 0) {
            ele = '&' + ele
          }
          andArr.push(ele)
        })
      })

      let newUrl = ''
      andArr.forEach((item) => {
        const nameIndex = item.indexOf(name + '=')
        // 不拼接要删除的参数
        if (nameIndex > -1) {
          // 保留第一个问号
          const questionIdx = item.indexOf('?')
          if (questionIdx == 0) {
            newUrl += '?'
          }
          return true
        }
        newUrl += item
      })
      // this.hasUrl = newUrl.replace(/\?&/g, '?');
      return newUrl.replace(/\?&/g, '?')
    },

    urlProcessing(urls) {
      // let urls = `${this.bsyqHref}/client/index.html#/my-page`;
      let getsUrl = this.delUrlParams(urls, 'token')
      getsUrl = this.delUrlParams(getsUrl, 'identity')
      if (getsUrl.endsWith('?')) {
        return getsUrl + 'token=' + this.token + '&identity=' + this.identity
      }
      return getsUrl.indexOf('?') > -1
        ? getsUrl + '&identity=' + this.identity
        : getsUrl + '?' + 'identity=' + this.identity
    }
  }
})
